// fetch user acl action
const ACL_FETCH = 'User/AclFetching';

const ACL_FETCH_SUCCESS = 'User/AclFetchSuccess';
const ACL_FETCH_ERROR = 'User/AclFetchError';

export { ACL_FETCH, ACL_FETCH_SUCCESS, ACL_FETCH_ERROR };
